import React, { useState, useEffect } from 'react';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';

const STATUS_BADGE = {
  'Aguardando':   { cls: 'badge-warn',  label: 'Aguardando' },
  'Agendada':     { cls: 'badge-warn',  label: 'Agendada' },
  'Em Execução':  { cls: 'badge-warn',  label: 'Em Execução' },
  'Concluída':    { cls: 'badge-ok',    label: 'Concluída' },
  'Cancelada':    { cls: 'badge-error', label: 'Cancelada' },
};

function OrdemServicoList() {
  const [ordens, setOrdens]     = useState([]);
  const [executores, setExecutores] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [executorId, setExecutorId]               = useState('');
  const [dataAgendadaInput, setDataAgendadaInput] = useState('');
  const [saving, setSaving] = useState(false);

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access_token')}` });

  useEffect(() => {
    fetchOrdens();
    fetchExecutores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrdens = async () => {
    try {
      const res = await api.get('/ordens-servico/', { headers: headers() });
      setOrdens(res.data);
    } catch {
      toast.error('Erro ao carregar as ordens de serviço.');
    } finally {
      setLoading(false);
    }
  };

  const fetchExecutores = async () => {
    try {
      const res = await api.get('/ordens-servico/executores/', { headers: headers() });
      setExecutores(res.data);
    } catch {
      toast.error('Erro ao carregar os usuários da empresa.');
    }
  };

  const handleEdit = (ordem) => {
    setEditingId(ordem.id);
    setExecutorId(ordem.executor || '');
    setDataAgendadaInput(ordem.data_agendada || '');
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setExecutorId('');
    setDataAgendadaInput('');
  };

  const handleSaveDetalhes = async (id) => {
    setSaving(true);
    try {
      const res = await api.patch(
        `/ordens-servico/${id}/`,
        { executor: executorId || null, data_agendada: dataAgendadaInput || null },
        { headers: { ...headers(), 'Content-Type': 'application/json' } }
      );
      setOrdens(ordens.map((o) => (o.id === id ? res.data : o)));
      toast.success('Ordem de serviço atualizada.');
      handleCancelEdit();
    } catch {
      toast.error('Erro ao atualizar a ordem de serviço.');
    } finally {
      setSaving(false);
    }
  };

  const handleIniciar = async (id) => {
    try {
      const res = await api.post(`/ordens-servico/${id}/iniciar/`, {}, { headers: headers() });
      setOrdens(ordens.map((o) => (o.id === id ? res.data : o)));
      toast.success('Execução iniciada.');
    } catch {
      toast.error('Erro ao iniciar a execução.');
    }
  };

  const handleConcluir = async (id) => {
    try {
      const res = await api.post(`/ordens-servico/${id}/concluir/`, {}, { headers: headers() });
      setOrdens(ordens.map((o) => (o.id === id ? res.data : o)));
      toast.success('Ordem de serviço concluída.');
    } catch {
      toast.error('Erro ao concluir a ordem de serviço.');
    }
  };

  const formatDate = (str) => {
    if (!str) return '—';
    return new Date(str + 'T00:00:00').toLocaleDateString('pt-BR');
  };

  const formatCurrency = (v) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Ordens de Serviço</h2>
        </div>
      </div>

      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">
            {ordens.length} ordem{ordens.length !== 1 ? 'ns' : ''} de serviço
          </span>
          <button className="prd-icon-btn" onClick={fetchOrdens} title="Atualizar">
            <span className="material-symbols-outlined">refresh</span>
          </button>
        </div>
        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th className="center" style={{ width: '5%' }}>Nº</th>
                <th>Cliente</th>
                <th className="center">Orçamento</th>
                <th className="right">Valor</th>
                <th className="center">Status</th>
                <th>Executor</th>
                <th className="center">Data Agendada</th>
                <th className="center">Data Conclusão</th>
                <th className="center">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 9 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : ordens.length === 0 ? (
                <tr>
                  <td colSpan={9} className="prd-empty">
                    Nenhuma ordem de serviço gerada ainda. Ela é criada automaticamente quando um orçamento
                    com item de serviço é aprovado.
                  </td>
                </tr>
              ) : (
                ordens.map((ordem) => {
                  const badge = STATUS_BADGE[ordem.status] || { cls: 'badge-warn', label: ordem.status };
                  const isEditing = editingId === ordem.id;
                  return (
                    <tr key={ordem.id} style={isEditing ? { background: '#fffbeb' } : {}}>
                      <td className="center" style={{ color: '#74777d', fontWeight: 600 }}>#{ordem.id}</td>
                      <td className="td-name">{ordem.cliente_nome}</td>
                      <td className="center">#{ordem.orcamento}</td>
                      <td className="right td-price">{formatCurrency(ordem.orcamento_valor_total)}</td>
                      <td className="center">
                        <span className={`badge ${badge.cls}`}>{badge.label}</span>
                      </td>
                      <td>
                        {isEditing ? (
                          <select
                            className="prd-input"
                            style={{ padding: '4px 8px', fontSize: '12px' }}
                            value={executorId}
                            onChange={(e) => setExecutorId(e.target.value)}
                          >
                            <option value="">Selecionar executor</option>
                            {executores.map((u) => (
                              <option key={u.id} value={u.id}>{u.nome}</option>
                            ))}
                          </select>
                        ) : (ordem.executor_nome || '—')}
                      </td>
                      <td className="center">
                        {isEditing ? (
                          <input
                            className="prd-input"
                            style={{ padding: '4px 8px', fontSize: '12px' }}
                            type="date"
                            value={dataAgendadaInput}
                            onChange={(e) => setDataAgendadaInput(e.target.value)}
                          />
                        ) : formatDate(ordem.data_agendada)}
                      </td>
                      <td className="center">{formatDate(ordem.data_conclusao)}</td>
                      <td className="center">
                        <div className="td-actions" style={{ justifyContent: 'center' }}>
                          {isEditing ? (
                            <>
                              <button
                                className="prd-icon-btn prd-icon-btn--active"
                                onClick={() => handleSaveDetalhes(ordem.id)}
                                disabled={saving}
                                title="Salvar"
                              >
                                <span className="material-symbols-outlined">check</span>
                              </button>
                              <button
                                className="prd-icon-btn"
                                onClick={handleCancelEdit}
                                title="Cancelar"
                              >
                                <span className="material-symbols-outlined">close</span>
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="prd-icon-btn"
                                onClick={() => handleEdit(ordem)}
                                title="Editar executor / data agendada"
                              >
                                <span className="material-symbols-outlined">edit</span>
                              </button>
                              {ordem.status !== 'Em Execução' && ordem.status !== 'Concluída' && ordem.status !== 'Cancelada' && (
                                <button
                                  className="prd-icon-btn"
                                  onClick={() => handleIniciar(ordem.id)}
                                  title="Iniciar execução"
                                >
                                  <span className="material-symbols-outlined">play_circle</span>
                                </button>
                              )}
                              {ordem.status !== 'Concluída' && ordem.status !== 'Cancelada' && (
                                <button
                                  className="prd-icon-btn"
                                  onClick={() => handleConcluir(ordem.id)}
                                  title="Concluir"
                                >
                                  <span className="material-symbols-outlined">task_alt</span>
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default OrdemServicoList;
